import { safeNumberFormat } from '@localization/safeIntl';

// This function generates a consistent number for a given day and search term combination.
// By combining the current date with the provided search term, we create a unique identifier
// that remains the same number during the day but will be different the other day simulating
// how many users search that particular search term

export function getConsistentNumber(inputString: string) {
  const scale32Bit = Math.pow(2, 32);
  const halfPi = 3.1415926 / 2;
  const min = 80;
  const max = 645;
  const rangeSize = max - min + 1;

  const combined = getTodaysDateString() + ':' + inputString;
  const hashValue = getHashCode(combined);
  const normalized = (hashValue + scale32Bit / 2) / scale32Bit; // 0 to 1
  const sin = Math.sin(halfPi * normalized);
  const result = Math.floor(sin * sin * rangeSize);
  return safeNumberFormat('en-US').format(result + min);
}

export function getHashCode(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    hash = (hash << 5) - hash + charCode;
    hash |= 0;
  }
  return hash;
}

function getTodaysDateString() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const hours = String(today.getHours()).padStart(2, '0');
  return `${year}-${month}-${day}-${hours}`;
}
